export enum httpVerb {
  get = 1,
  post = 2,
  patch = 3,
  put = 4,
  delete = 5
}
